import React from 'react';
import './ResetPasswordExpired.scss';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

const ResetPasswordExpired: React.FC = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className='d-flex justify-content-center pt-5'>
                <img
                    alt='mooveno-logo'
                    className="logo"
                    src={`/login/mooveno-logo-dark.svg`}
                    style={{ width: 200, height: 'auto', maxWidth: '90%', cursor: 'pointer' }}
                    onClick={() => navigate('/')}
                />
            </div>
            <div className='card-margins d-flex justify-content-center row'>
                <Card style={{ borderRadius: '14px', maxWidth: 480, width: '100%' }}>
                    <div className="d-flex flex-column align-items-center pb-2">
                        <img
                            alt='expired-token'
                            className="logo"
                            src={`/sidebar/orders-sidebar.svg`}
                            style={{ width: 100, height: 'auto', maxWidth: '90%' }}
                        />
                        <h2>Token wygasł</h2>
                        <span className="text-center mb-4" style={{ fontWeight: 400, color: '#4C6483' }}>
                            Link do resetowania hasła wygasł lub jest nieprawidłowy.
                        </span>
                        <div className='d-flex justify-content-center text-justify px-5 mb-4' style={{ fontSize: '14px' }}>
                            <span>Linki resetujące są ważne przez 15 minut.<br></br>
                                Możesz poprosić o nowy link resetujący.</span>
                        </div>
                        <Button
                            className="login-button"
                            label={"Poproś o nowy link"}
                            onClick={() => navigate('/reset-password/')}
                            style={{ borderRadius: '10px' }}
                        />
                        <Button
                            className="go-back-login-button mt-3"
                            label={"Powrót do logowania"}
                            icon="pi pi-arrow-left"
                            iconPos="left"
                            onClick={() => navigate('/login/')}
                            style={{ borderRadius: '10px' }}
                        />
                    </div>
                </Card>
                <p className='d-flex justify-content-center pt-4'>© 2025 Mooveno. Wszystkie prawa zastrzeżone</p>
            </div>
        </>
    );
};

export default ResetPasswordExpired; 